// Hero.js (example)
import { useEffect } from 'react';
import { getApp } from '../Config/app';
import { Button } from '../Shared/Styled';
import {Ts} from '../Config/switcher';

const GetApp = ({service, lang, connected}) => {

  const T = (value, key='getApp') => Ts(lang, key, value)

  useEffect(() => {

  }, [service, lang]);

  // Function to handle the download of the app very smartly
  // It creates a link element, sets the href to the app URL, and triggers a click event to download the file
  const onDownload = () => {
    if(connected) 
    {
        const link = document.createElement('a'); 
        link.href = getApp.url; 
        link.download = getApp.url.substring(getApp.url.lastIndexOf('/') + 1); 
        document.body.appendChild(link); 
        link.click(); 
        document.body.removeChild(link);
    }
    else 
    {
        alert(T('connected', 'home'))
    }
}
  
  return (
    <div id="GetApp">
        <div className="col-md-4" >
              <img style={{width:'50%'}} src={getApp.image}  onClick={()=>onDownload()} title={T('info')} />
        </div>
        <div className="col-md-4">
          <a style={{textDecoration:'none'}}  onClick={()=>onDownload()} title={T('info')}>
            <h2>{T('name')}</h2>
          </a>
        </div>
        <div className="col-md-4">
          <Button onClick={()=>onDownload()} style={{height:'6rem'}} title={T('info')}>{T('name')}</Button>
        </div>
    </div>
  );
};

export default GetApp;

